<template>
  <el-dialog :title="$t('plugin.examPass.title')" :visible="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="realName" :label="$t('plugin.examPass.realName')" align="center"></el-table-column>
      <el-table-column prop="userName" :label="$t('plugin.examPass.accountName')" align="center"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('plugin.examPass.enrollTime')" align="center" min-width="100"></el-table-column>
      <el-table-column :label="$t('plugin.examPass.status')" align="center" min-width="100">
        <template slot-scope="scope">{{ scope.row.state == 1 ? $t('plugin.examPass.passed') : $t('plugin.examPass.notPassed') }}</template>
      </el-table-column>
      <el-table-column prop="tel" :label="$t('plugin.examPass.contact')" align="center"></el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :current-page="params.page" @current-change="handleCurrentChange"></el-pagination>
  </el-dialog>
</template>

<script>
import { getTextList } from '@/api/plugins.js';
export default {
  name: 'labelSave',
  data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      params: {
        id: '',
        page: 1
      },
      total: 0
    };
  },
  methods: {
    init(id) {
      this.dialogFormVisible = true;
      if (id) {
        this.params.id = id;
        this.getNumList();
      }
    },
    getNumList() {
      getTextList(this.params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data;
        }
      });
    },
    close() {
      this.dialogFormVisible = false;
      this.$emit('callbackclose');
    },
    handleCurrentChange(msg) {
      this.params.page = msg;
      this.getNumList();
    }
  }
};
</script>
